import { KALEIDOSCOPE } from '../theme/kaleidoscope';

export const ENTITY_TYPE_LABELS: Record<string, string> = {
  project: 'Project',
  repository: 'Repository',
  service: 'Service',
  flow: 'Flow',
  workflow: 'Workflow',
  subflow: 'Subflow',
  api: 'API',
  incident: 'Incident',
  investigation: 'Investigation',
  change_request: 'Change Request',
  engineering_episode: 'Engineering Episode',
  worker: 'Worker',
  worker_insight: 'Worker Insight',
  knowledge_node: 'Knowledge Node',
  source_file: 'Source File',
  config_file: 'Configuration',
  document: 'Document',
  dependency: 'Dependency',
  datastore: 'Datastore',
  component: 'Component',
  environment: 'Environment',
  infrastructure_asset: 'Infrastructure',
};

export const ENTITY_TYPE_ICONS: Record<string, string> = {
  project: '📁',
  repository: '📦',
  service: '⚙️',
  flow: '🔀',
  workflow: '🔀',
  api: '🌐',
  incident: '🚨',
  investigation: '🔬',
  change_request: '📋',
  engineering_episode: '🧠',
  worker: '🤖',
  worker_insight: '💡',
  knowledge_node: '🕸️',
  source_file: '📄',
  config_file: '⚙️',
  document: '📝',
  dependency: '🔗',
  datastore: '🗄️',
  component: '🧩',
  environment: '🌍',
};

export function entityTypeLabel(type: string): string {
  return ENTITY_TYPE_LABELS[type] ?? type.replace(/_/g, ' ');
}

export function entityTypeIcon(type: string): string {
  return ENTITY_TYPE_ICONS[type] ?? '◆';
}

export function entityTypeColor(type: string): string {
  switch (type) {
    case 'incident':
    case 'investigation':
      return KALEIDOSCOPE.operate;
    case 'change_request':
    case 'engineering_episode':
      return KALEIDOSCOPE.change;
    case 'service':
    case 'workflow':
    case 'worker':
    case 'worker_insight':
      return KALEIDOSCOPE.understand;
    case 'repository':
    case 'source_file':
    case 'document':
      return KALEIDOSCOPE.discover;
    default:
      return KALEIDOSCOPE.chrome;
  }
}
